// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  MasterPage,
  PaginaNaoEncontrada,
} from './';

export default {
  path: 'master-page',
  name: 'Master page',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: '/MasterPage', name: 'Master page', component: MasterPage },
    { path: 'PaginaNaoEncontrada', name: 'Pagina nao encontrada', component: PaginaNaoEncontrada },
  ],
};



// WEBPACK FOOTER //
// ./src/features/master-page/route.js